<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Pesan Keluar</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item" v-if="param_broadcast_id != ''">
                    <router-link :to="'/broadcast-info-v2?id=' + param_broadcast_id">Broadcast</router-link>
                  </li>
                  <li class="breadcrumb-item active">Pesan Keluar</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row" v-if="!selectedTable.length">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input class="form-control floating" v-model="serverParams.columnFilters.period" type="month" />
                <label class="focus-label">Period</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group">
                <!-- <input
                  class="form-control floating"
                  v-model="serverParams.columnFilters.license_id"
                  type="text"
                />
                <label class="focus-label">License ID</label>-->
                <multiselect :class="'form-control'" v-model="selectedContact" id="ajax" label="license_name"
                  track-by="id" :placeholder="''" :multiple="true" open-direction="bottom" :custom-label="customLabel"
                  :options="contactOptions" :searchable="true" :loading="isLoading" :internal-search="false"
                  :close-on-select="false" :options-limit="300" :limit="3" :limit-text="limitText" :max-height="600"
                  :show-no-results="true" :hide-selected="true" @search-change="asyncFind" :show-labels="false">
                  <template slot="tag" slot-scope="{ option, remove }">
                    <span class="custom__tag">
                      <span>{{ option.license_name + " (" + option.license_phone_number + ")" }}</span>
                      <span class="custom__remove" @click="remove(option)">❌</span>
                    </span>
                  </template>
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="selectedContact.length"
                      @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus select-focus">
                <select class="form-control" v-model="serverParams.columnFilters.status">
                  <option :value="''">-- Select --</option>
                  <option :value="'success'">Success</option>
                  <option :value="'pending'">Pending</option>
                  <option :value="'error'">Error</option>
                  <option :value="'delete'">Delete</option>
                </select>
                <label class="focus-label">Status</label>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <a href="javascript:void(0)" @click.prevent="searchData" class="btn btn-success btn-block">Search</a>
            </div>
          </div>
          <div class="row filter-row" v-if="selectedTable.length">
            <div class="col-sm-6 col-md-3">
              <div class="form-group">
                <button :disabled="isLoading" @click.prevent="actionDelete" class="btn btn-danger btn-block">
                  <i class="la la-trash"></i> Remove
                </button>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group">
                <button :disabled="isLoading" @click.prevent="actionResend" class="btn btn-secondary btn-block">
                  <i class="la la-refresh"></i> Resend
                </button>
              </div>
            </div>
            <div class="col-sm-6 col-md-6">
              <div class="text-right">
                <!-- <button class="btn btn-success btn-block">Scrape</button>-->
                <a @click.prevent="hideActions" class="btn btn-xs">
                  <i class="fa fa-close"></i> Close
                </a>
              </div>
            </div>
          </div>

          <div class="row filter-row" v-if="!selectedTable.length">
            <div class="col-sm-6 col-md-3">
              <div class="form-group" v-if="totalRecords>0">
                <button :disabled="isLoading" @click.prevent="listMessageExcel" class="btn btn-primary btn-block">
                  <i class="fa fa-download"></i> Excel
                </button>
              </div>
            </div>
          </div>
          <!-- /Search Filter -->
          <div class="row">
            <div class="col-md-12">
              <div v-if="linkDownload != ''" class="alert alert-success">Data berhasil dibuat, silakan klik <a
                  :href="linkDownload" target="_blank">link</a> berikut jika download otomatis tidak berfungsi. <a
                  class="text-danger" @click="closeMessageLinkDownload"><i class="fa fa-remove"></i></a></div>
              <div class="table-responsive">
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th>
                        <div class="checkbox">
                          <label>
                            <input type="checkbox" v-model="selectAllTable" />
                          </label>
                        </div>
                      </th>
                      <th>License</th>
                      <th>Agent</th>
                      <th>To</th>
                      <th style="width:200px;">Chat</th>
                      <th>Time</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr>
                        <td colspan="7">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-if="rows.length">
                      <tr v-for="(row, index) in rows" :key="index">
                        <!-- <td>{{row.number}}</td> -->
                        <td>
                          <div class="checkbox">
                            <label>
                              <!-- <input type="checkbox" name="checkbox" /> -->
                              <input type="checkbox" v-model="selectedTable" :value="row" />
                            </label>
                          </div>
                        </td>
                        <td class="text-wrap" :id="'license_name_' + row.id">

                        </td>
                        <td>{{ row.agent_first_name }}</td>
                        <td class="text-wrap">
                          <i class="fa fa-phone-square"></i>
                          <small>{{ getWhatsappNumberFromJid(row.message_number) }}</small>
                          <br />
                          <small class="text-muted">{{ row.message_name }}</small>
                        </td>
                        <td class="text-wrap">
                          <span v-if="row.message_type == 'text'">{{ row.message }}</span>
                          <span v-else>&lt;{{ row.message_type }}&gt;</span>
                        </td>
                        <td class="text-center">{{ formatLocalDate(row.update_datetime) }}</td>
                        <td class="text-center">
                          <template v-if="row.status == 0">
                            <span :class="'text text-danger'">
                              <i class="fa fa-exclamation"></i>
                              {{ labelStatusMessage(row.status) }}
                              <br />
                              <small>{{ row.status_reason }}</small>
                            </span>
                          </template>
                          <template v-if="row.status == 1">
                            <span :class="'text text-warning'">
                              <i class="fa fa-pause"></i>
                              {{ labelStatusMessage(row.status) }}
                            </span>
                          </template>
                          <template v-if="row.status > 1">
                            <span :class="'text text-success'">
                              <i class="fa fa-check"></i>
                              {{ labelStatusMessage(row.status) }}
                            </span>
                          </template>
                          <template v-if="row.is_deleted == '1'">
                            <br />
                            <i class="text-danger">Deleted</i>
                          </template>

                        </td>
                      </tr>
                    </template>
                    <template v-if="loading">
                      <tr>
                        <td colspan="7">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="rows.length < 1 && !loading">
                      <tr>
                        <td colspan="5" class="text-center">-empty-</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select @change="onPerPageChange(serverParams.perPage)" autocomplete="off" name="perPageSelect"
                v-model="serverParams.perPage" style="width: 100px;" class="select-to-paginasi">
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="30">30 / page</option>
                <option value="40">40 / page</option>
                <option value="50">50 / page</option>
              </select>
              <span class="footer__row-count__label">of {{ totalRecords }} total records</span>
            </div>
            <div class="col-sm-12 col-md-6 text-right" v-if="serverParams.perPage < totalRecords">
              <a href="javascript:void(0)" @click="onPrevChange(parseInt(currentPage))" tabindex="0" class="btn"
                :class="{ disabled: parseInt(currentPage) - 1 <= 0 }">
                <span class="chevron left"></span>
                <span>Prev</span>
              </a>
              page
              <input style="width:100px;" min="1" type="number" v-model="currentPage"
                @keyup.enter="onPageChange(parseInt(currentPage))" class />
              of {{ Math.ceil(totalRecords / serverParams.perPage) }}
              <a href="javascript:void(0)" @click="onNextChange(parseInt(currentPage))" tabindex="0"
                class="footer__navigation__page-btn" :class="'btn ' + {
                  disabled:
                    parseInt(currentPage) + 1 >
                    Math.ceil(totalRecords / serverParams.perPage)
                }">
                <span>Next</span>
                <span class="chevron right"></span>
              </a>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import {
  formatLocalDate,
  nFormatter,
  getCurrentMonth,
  formatDate,
  labelStatusMessage,
  getWhatsappNumberFromJid
} from "@/utils/helper";

import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import { Skeleton } from "vue-loading-skeleton";

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { listMessageExcel } from "../../api/messageReport";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    Multiselect
  },
  data() {
    return {
      linkDownload: '',
      param_broadcast_id: '',
      selectedTable: [],
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 20
      },
      isLoading: false,
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        columnFilters: {
          broadcast_id: "",
          from_me: 1,
          license_id: "",
          period: this.getCurrentMonth(),
          status: ""
        },
        page: 1,
        perPage: 20 // perPage
      }
    };
    //  isactive : true
  },
  computed: {
    selectAllTable: {
      get: function () {
        return this.rows
          ? this.selectedTable.length == this.rows.length
          : false;
      },
      set: function (value) {
        var selectedTable = [];

        if (value) {
          this.rows.forEach(function (row) {
            // selectedTable.push(row.id);
            selectedTable.push(row);
          });
        }

        this.selectedTable = selectedTable;
      }
    }
  },
  watch: {
    selectedContact: {
      handler: function (val, oldVal) {
        // console.log("val.id", val.id, val.length);
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedLicense = val;
        }
        if (val.length == 1) {
          this.serverParams.columnFilters.license_id = val[0].id;
          this.searchData();
        } else {
          this.serverParams.columnFilters.license_id = "";
          this.searchData();
        }
        // if (val.id != "") {
        //   this.serverParams.columnFilters.license_id = val.id;
        //   // console.log("val.id", val.id);
        //   this.searchData();
        // } else {
        //   this.serverParams.columnFilters.license_id = "";
        //   this.searchData();
        // }
      },
      deep: true
    }
  },
  created() {
    this.asyncFind("");

    this.loadItems();
    this.currentPage = this.serverParams.page;
  },
  methods: {
    closeMessageLinkDownload() {
      this.linkDownload = '';
    },
    listMessageExcel() {
      this.isLoading = true;
      this.$store
        .dispatch("messageReport/listMessageExcel", this.serverParams)
        .then(response => {
          this.isLoading = false;
          this.linkDownload = response.data;
          if (this.linkDownload != '') {
            window.open(this.linkDownload, '_blank').focus();
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    async getLicenseById(licenseId, id) {
      // const formValuePrice = document.querySelector( '.form-price-value' );

      // this.loading = await true;
      await this.contactOptions.forEach((data, idx) => {
        if (data.id === licenseId) {
          // console.log("dataaa", data.license_name)
          // console.log("ceeee", this.$refs["license_name_" + id])
          console.log(document.getElementById('td#license_name_' + id))
          let spanName = document.querySelector('td#license_name_' + id)
          // let varName='license_name_'+id
          // console.log("ceeee", this.$refs[varName])  
          // this.$refs["license_name-" + id][0].innerHTML =
          // return 'a'
          spanName.innerHTML = data.license_phone_number + " <br /><small class='text-muted'>" + data.license_name + "</small>"
          // return '<b>' + data.license_name + '</b>';
        }
      })
      // await this.$store
      //   .dispatch("license/getLicenseById", licenseId)
      //   .then(response => {
      //     var { data } = response;
      //     this.$refs["license_name-" + id][0].innerHTML =
      //       '<b>' + data.license_name + '</b>';

      //     //   console.log("response", response);
      //   });
      // this.loading = await false;
    },
    hideActions() {
      this.selectAllTable = false;
      this.selectedTable = [];
    },
    actionResend() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to resend " +
          this.selectedTable.length +
          " messages?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable
            };
            this.$store
              .dispatch("omniwa/resendMessage", newParam)
              .then(response => {
                this.$fire({
                  title: "Processing",
                  text: "Resend message is on the way",
                  type: "warning",
                  timer: 2000
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;
                var that = this;
                setTimeout(function () {
                  that.searchData();
                }, 500);
              })
              .catch(e => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    actionDelete() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to permanently erase " +
          this.selectedTable.length +
          " messages?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable
            };
            this.$store
              .dispatch("omniwa/deleteMessage", newParam)
              .then(response => {
                this.$fire({
                  title: "Success Delete",
                  text: "The data was successfully deleted",
                  type: "success",
                  timer: 2000
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;

                this.searchData();
              })
              .catch(e => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ license_name, license_phone_number }) {
      return `${license_name} – ${license_phone_number}`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.license_name = query;
      this.$store
        .dispatch("license/getLicenseList", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
          // console.log("query: ", query);
          // console.log("contactOptions: ", this.contactOptions);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
      // ajaxFindCountry(query).then(response => {
      //   this.countries = response;
      //   this.isLoading = false;
      // });
    },
    clearAll() {
      this.selectedContact = [];
    },
    getWhatsappNumberFromJid(value) {
      return getWhatsappNumberFromJid(value);
    },
    labelStatusMessage(value) {
      return labelStatusMessage(value);
    },
    async setResolve(roomId) {
      await this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (typeof r.value != "undefined" && r.value == true) {
          await this.$store
            .dispatch("omniroom/setResolve", roomId) // sesuai kan dengan method di API
            .then(response => {
              this.searchData();
              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              });
            });
          // .catch(error => {
          //   this.$fire({
          //     title: "Error",
          //     text: error.response.data.msg,
          //     type: "error",
          //     timer: 2000
          //   });
          //   console.log(error);
          // });
        }
      });
    },
    formatLocalDate(value) {
      return formatLocalDate(value);
    },
    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },
    formatDate(value) {
      return formatDate(value);
    },
    getCurrentMonth() {
      return getCurrentMonth();
    },
    nFormatter(value) {
      return nFormatter(value);
    },
    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();

      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    async loadItems() {
      if (
        typeof this.$route.query.broadcast_id != "undefined" &&
        this.$route.query.broadcast_id != ""
      ) {
        this.serverParams.columnFilters.broadcast_id = this.$route.query.broadcast_id;
        this.param_broadcast_id = this.serverParams.columnFilters.broadcast_id
        this.serverParams.columnFilters.period = "";
      }
      if (
        typeof this.$route.query.status != "undefined" &&
        this.$route.query.status != ""
      ) {
        this.serverParams.columnFilters.status = this.$route.query.status;
      }
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("messageReport/listMessage", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;

          var that = this
          setTimeout(function () {
            that.rows.forEach((row, index) => {
              that.getLicenseById(row.license_id, row.id);
            });
          }, 100)


          // console.log("rows", this.rows);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "summary_"
};
</script>


// WEBPACK FOOTER //
// src/views/messageReport/outbox.vue